
import { mapGetters, mapState, mapActions } from 'vuex'

import { DEFAULT_CODE } from '@/constants/'
import PoxChart from './PoxChart'
import SupplyDemandInfo from './SupplyDemandInfo'

import Consensus from './Consensus'


export default {
    components: {
        PoxChart,
        SupplyDemandInfo,
        Consensus
    },
    data() {
        return {
            closeChartBox: false,
        }
    },
    computed: {
        ...mapGetters('search', ['getCode', 'getSupplyData']),
        ...mapState('search', ['corp']),
        corpCode() {
            return this.corp.code;
        },
        corpOutline() {
            return this.corp;
        },
    },
    watch: {
        corpCode(newCode, oldCode) {
            if (newCode !== oldCode) {
                this.loadCorpData(newCode);
            }
        },
        getCode(newCode, oldCode) {
            if (newCode !== oldCode) {
                this.loadCorpData(newCode);
            }
        }
    },
    created() {

        this.loadCorpData(this.corpCode);

    },
    methods: {
        ...mapActions('search', [
            'GET_CORP_INFO', 'GET_CORP_CONSENSUS', 'GET_CORP_CONSENSUS_CHART'
        ]),
        loadCorpData(code) {
            this.SearchInfo(code);
            this.SearchConsensusChart(code);
            this.SearchConsensus(code);
        },
        SearchInfo(code) {
            this.GET_CORP_INFO(code)
        },
        SearchConsensusChart(code) {
            this.GET_CORP_CONSENSUS_CHART(code)
        },
        SearchConsensus(code) {
            this.GET_CORP_CONSENSUS(code)
        },
        
    },
}
